import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { useState } from 'react';
import {
  finishDraft,
  setCurrentStep,
  setStepsArray,
} from 'store/modules/openClaim/actions';

import ButtonContainer from '../components/ButtonContainer';
import ModalSaveDraft from '../components/ModalSaveDraft';
import ModalEndDraft from '../components/ModalEndDraft';
import useModalSaveDraft from '../useModalSaveDraft';
import {
  Card01,
  Card02,
  Card03,
  Card04,
  Card05,
  Card06,
  Card07,
} from './cards';

import { Wrapper } from './styles';

export const Step5 = (): JSX.Element => {
  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  const dispatch = useDispatch();
  const {
    openModal,
    setOpenModal,
    stateModal,
    setStateModal,
    saveDraftAndLeave,
    onClickCancel,
  } = useModalSaveDraft('step5');

  const [openModalEndDraft, setOpenModalEndDraft] = useState(false);

  const [stateModalEndDraft, setStateModalEndDraft] = useState({
    display: 1, // 1 = ok, 2 = erro, 3 = erro nulo
    errorMessage: '',
  });

  const onClickForward = () => {
    if (stateClaim.step.step2.estimateLoss) {
      try {
        dispatch(finishDraft());
        setOpenModalEndDraft(true);
        setStateModalEndDraft({
          ...stateModal,
          display: 1,
        });
      } catch {
        setOpenModalEndDraft(true);
        setStateModalEndDraft({
          ...stateModal,
          display: 2,
        });
      }
    } else {
      setOpenModalEndDraft(true);
      setStateModalEndDraft({
        ...stateModal,
        display: 3,
      });
    }
  };

  const handleSubmit = () => {
    saveDraftAndLeave(null);
  };

  const editStep = (step: number) => {
    dispatch(setStepsArray([step, 5])); // edita o passo e volta para o resumo ao salvar e avancar
    dispatch(setCurrentStep(step));
  };

  return (
    <Wrapper>
      <Card01 editStep={editStep} stateClaim={stateClaim} />
      <Card02 editStep={editStep} stateClaim={stateClaim} />
      <Card03 editStep={editStep} stateClaim={stateClaim} />
      <Card04 editStep={editStep} stateClaim={stateClaim} />
      <Card05 editStep={editStep} stateClaim={stateClaim} />
      <Card06 editStep={editStep} stateClaim={stateClaim} />
      <Card07 editStep={editStep} stateClaim={stateClaim} />

      <ButtonContainer
        onClickForward={onClickForward}
        onClickCancel={onClickCancel}
        disabled={false}
      />
      <ModalSaveDraft
        stateModal={stateModal}
        setStateModal={setStateModal}
        isOpen={openModal}
        setIsOpen={setOpenModal}
        handleSubmit={handleSubmit}
      />
      <ModalEndDraft
        stateModal={stateModalEndDraft}
        setStateModal={setStateModalEndDraft}
        isOpen={openModalEndDraft}
        setIsOpen={setOpenModalEndDraft}
        idTimeline={stateClaim.draftId || ''}
      />
    </Wrapper>
  );
};
